import React, { useRef, useState, useEffect } from 'react';
import PropTypes from 'prop-types';

function PageAutoCompleteDropdown({label, options, value, onSelect}) {
  const [location, setLocation] = useState(value || {});
  const [isOpen, setIsOpen] = useState(false);

  const selectRef = useRef();

  useEffect(() => {
    if (options && options.length === 1) {
      setLocation(options[0]);
      onSelect(options[0]);
      setIsOpen(false);
    }
  }, [options, onSelect]);
  
  useEffect(() => {
    const checkIfClickedOutside = (e) => {
      if (isOpen && selectRef.current && !selectRef.current.contains(e.target)) {
        setIsOpen(false);
      }
    };

    document.addEventListener('mousedown', checkIfClickedOutside);

    return () => {
      // Cleanup the event listener
      document.removeEventListener('mousedown', checkIfClickedOutside);
    };
  }, [isOpen]);

  useEffect(() => {
    setLocation(value)
  }, [value])

  const handleSelect = (value) => {
    setLocation(value);
    onSelect(value)
    setIsOpen(false);
  };

  const renderList = (listData) => listData ? (
    <div className="
      absolute w-full bg-[#F8F9FB] text-[#231F20] top-2 rounded-3xl shadow-md mt-1 max-h-60 z-10 overflow-hidden
    ">
      <div className="h-[62px] border-b rounded-full" />
      <div className="max-h-60 overflow-auto pb-16">
        <ul>
          {listData.map((item, index) => (
            <li key={index} onClick={() => handleSelect(item)}
                className="px-6 py-3 pl-8 hover:bg-gray-100 cursor-pointer">
              {item.formattedAddress}
            </li>
          ))}
        </ul>
      </div>
    </div>
  ) : null;

return (
  <div className="w-full px-4 py-2">
    <div
      ref={selectRef}
      onClick={() => {
        if (!(options && options.length === 1)) setIsOpen(!isOpen);
      }}
      className={`relative text-left rounded-full bg-[#F8F9FB] bg-opacity-80 h-[71px] cursor-pointer ${options && options.length === 1 ? 'opacity-60 cursor-not-allowed' : ''}`}
    >
      <div className="px-3 py-3 border-b rounded-full">
        <label htmlFor="bagType" className={`
          relative font-bold text-[#1C2938] pl-4 mb-2 ${isOpen ? 'z-20' : ''}
        `}>
          {label}
        </label>
        <div className={`
          relative w-full flex items-center justify-between pl-4 text-sm font-normal
          text-[#1C2938] bg-transparent focus:outline-none rounded-full
          ${isOpen ? 'z-20' : ''}
        `}>
          <span>
            { location.formattedAddress ? `${location.formattedAddress}`
              : <span className="opacity-50">Please Choose</span>}
          </span>
          <svg
            width="24" height="24" fill="rgba(35, 31, 32, 0.5)"
            xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"
          >
            <path d="
                M5.293 7.293a1 1 0 0 1 1.414 0L10 10.586l3.293-3.293a1
                1 0 1 1 1.414 1.414l-4 4a1 1 0 0 1-1.414 0l-4-4a1 1 0 0 1 0-1.414z
            "/>
          </svg>
        </div>
      </div>
      {(isOpen && !(options && options.length === 1)) && renderList(options)}
    </div>
  </div>
);
}

PageAutoCompleteDropdown.propTypes = {
  options: PropTypes.array.isRequired,
  onSelect: PropTypes.func.isRequired,
  label: PropTypes.string,
  value: PropTypes.any
};

export default PageAutoCompleteDropdown;
